import { SVGProps } from "react";

const IconUsers = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}
        >
            <path
                d="M13.1982 10C11.5414 10 10.1982 8.65685 10.1982 7C10.1982 5.34315 11.5414 4 13.1982 4C14.8551 4 16.1982 5.34315 16.1982 7C16.1982 8.65685 14.8551 10 13.1982 10Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M20.1982 18C20.1982 13 17.0536 13 13.1982 13C9.34292 13 6.19824 13 6.19824 18"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M8.51645 9.6888C8.19972 10.0626 7.76092 10.3356 7.24532 10.4391C6.02083 10.6849 4.82691 9.88126 4.57863 8.64421C4.33035 7.40716 5.12173 6.20511 6.34623 5.95935C6.79631 5.86902 7.24227 5.92046 7.63865 6.08309"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M1.80176 16.052C1.80176 12.8142 3.3804 12.44 5.45703 12.3967"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default IconUsers;
